import './index.css';
import { loadDict, tr } from './i18n';

loadDict()
  .catch(() => {})
  .then(() => import('./boot'))
  .catch(() => {
    document.getElementById('root')!.textContent = tr('Не удалось загрузить CRM. Обновите страницу.');
  });
